export default __webpack_public_path__ + "static/media/BANNER1.df95793f.jpg";